module.exports = __webpack_public_path__ + "static/media/euler_hermes_logo.541bd01c.jpeg";